export default "__VITE_ASSET__BUaRH7FX__"